export default __webpack_public_path__ + "static/media/illustration_benefit3.d668e014.png";